/* eslint-disable */
import dayjs, { isDayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  DEFAULT_DISPLAY_DATETIME_FORMAT,
  DEFAULT_EMPTY_VALUE,
} from 'utils/constants';

import {
  DATE_MONTH,
  DATE_DAY,
  DATE_YEAR,
} from '../../components/DateTimePicker/CustomInput';
import {
  TIME_HOUR,
  TIME_MINUTE,
} from '../../components/Forms/Fields/TimePicker/TimePickerItems/index';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const systemTimezone = new Intl.DateTimeFormat().resolvedOptions()
  .timeZone;
export const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
// TAKE NOTE: convert to UTC time
export const convertTime = (
  timestamp,
  format = DEFAULT_DISPLAY_DATETIME_FORMAT,
) => {
  if (timestamp === null) return '-';

  return dayjs(timestamp)
    .utc()
    .format(format);
};
/**
 * @param {string} timestamp - UTC string from server
 * @param {string} timezone - specified timezone
 * @returns {string} display string
 */
export const displayDateTimeInSpecifiedTZ = ({
  timestamp,
  format = DEFAULT_DISPLAY_DATETIME_FORMAT,
}) => {
  return dayjs(timestamp)
    .tz(systemTimezone, true) // On passing a second parameter as true, only the timezone (and offset) is updated, keeping the local time same
    .format(format);
};

// THIS display time is for displaying in any timezone, default to system timezone
export const displayTime = ({
  timestamp,
  format = DEFAULT_DISPLAY_DATETIME_FORMAT,
}) => {
  if (timestamp)
    return dayjs(
      new Date(timestamp).toLocaleString('en-US', { timeZone: systemTimezone }),
    ).format(format);
  return DEFAULT_EMPTY_VALUE;
};

export const convertDateTime = (timestamp, format = 'DD-MM-YYYY') => {
  return dayjs(timestamp)
    .utc()
    .format(format);
};

export const startOfDay = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .startOf('day')
    .utc()
    .format(format);
};
export const startOfWeek = ({ date, format = DATE_TIME_FORMAT, timezone }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .startOf('week')
    .utc()
    .format(format);
};
export const endOfWeek = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .endOf('week')
    .utc()
    .format(format);
};
export const endOfMonth = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .endOf('month')
    .utc()
    .format(format);

  // another way getting end of month
  // const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
};
export const startOfMonth = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .startOf('month')
    .utc()
    .format(format);
};

export const convertToUTCTime = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;
  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .utc()
    .format(format);
};

export const displayDate = ({ date, format = 'YYYY-MM-DD' }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .add(1, 'day')
    .utc()
    .format(format);
};

export const endOfDay = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .add(1, 'day')
    .startOf('day')
    .utc()
    .format(format);
};
export const addFivedays = ({ date, format = DATE_TIME_FORMAT }) => {
  const stringDateTime = isDayjs(date) ? date.toString() : date;

  return dayjs(
    new Date(stringDateTime).toLocaleString('en-US', {
      timeZone: systemTimezone,
    }),
  )
    .add(5, 'day')
    .startOf('day')
    .utc()
    .format(format);
};

export const getTimeInSeconds = mins => {
  return mins * 60;
};

export const getTimeInMins = seconds => {
  return seconds / 60;
};

export const formatTimeDifference = (startTime, endTime) => {
  const endTimestamp = dayjs(endTime);
  const startTimestamp = dayjs(startTime);
  return formatDuration(endTimestamp.diff(startTimestamp, 'second'));
};

export const convertDatetimeToFixedInterval = time => {
  const timeArray = time.split(':');

  return (parseInt(timeArray[0]) * 60 + parseInt(timeArray[1])) / 5;
};

export const conversionOfTime = (seq, interval) => {
  const timeInMins = seq * interval;
  const numberOfHours = Math.floor(timeInMins / 60);
  const numberOfMins = timeInMins % 60;

  return `${numberOfHours > 9 ? numberOfHours : `0${numberOfHours}`}:${
    numberOfMins > 9 ? numberOfMins : `0${numberOfMins}`
  }`;
};

export const formatDuration = numberOfSeconds => {
  if (Math.abs(numberOfSeconds) < 60) {
    return `${numberOfSeconds}s`;
  }

  let totalMinutes = Math.floor(numberOfSeconds / 60);
  let totalHours = Math.floor(totalMinutes / 60);
  totalMinutes -= totalHours * 60;
  const totalDays = Math.floor(totalHours / 24);
  totalHours -= totalDays * 24;
  return `${totalDays > 0 ? `${totalDays}d ` : ''}${
    totalHours > 0 ? `${totalHours}h ` : ''
  }${totalMinutes}m`;
};

export const compareDates = (firstDate, secondDate) => {
  if (firstDate > secondDate || firstDate === secondDate) {
    return firstDate;
  } else {
    return secondDate;
  }
};

export const isDate = date => {
  const _regExp = new RegExp(
    '^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$',
  );
  return _regExp.test(date);
};

export const constructDateObject = (timestamp, format) => {
  const dateType = format ? dayjs(timestamp, format) : dayjs(timestamp);

  return {
    [DATE_DAY]: dateType.format('DD'),
    [DATE_MONTH]: dateType.format('MM'),
    [DATE_YEAR]: dateType.format('YYYY'),
    [TIME_HOUR]: dateType.format('HH'),
    [TIME_MINUTE]: dateType.format('mm'),
  };
};

export const hourMinuteToObject = value => {
  const arrayTime = value.split(':');
  const [hour, minute] = arrayTime;

  return { hour, minute };
};

/**
 * @param {string} date - UTC string from server
 * @param {string} compareParam - can be date, year or month
 * @returns {boolean} true or false
 */
export const isSameAsToday = ({ date, compareParam }) => {
  return dayjs().isSame(date, compareParam);
};
// /**
//  *
//  * @param {string} startDate
//  * @param {string} endDate
//  * @param {string} unit
//  * @param {string} granularity
//  * @returns {boolean} true or false
//  *
//  * Parameter 4 is a string with two characters; '[' means inclusive, '(' exclusive
//  *'()' excludes start and end date (default)
//  *'[]' includes start and end date
//  *'[)' includes the start date but excludes the stop
//  */
export const isTodayinRange = ({
  startDate,
  endDate,
  unit = 'day',
  granularity = '[]',
}) => {
  const mDay = dayjs();
  const sDate = dayjs(startDate);
  const eDate = dayjs(endDate);
  return mDay.isBetween(sDate, eDate, unit, granularity);
};
